// Libs
import React, { useEffect, useMemo, useState } from 'react'

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
    exportarCrfProjetoContaContabilCcRelatorioCentroDeCustoForcast,
    getAllCrfProjetoContaContabilCcRelatorioCentroDeCustoForcast,
    IRelatorioCentroDeCustoResult
} from '@app/api/crf/crfProjeto';

//Files
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';

//Utils
import { compareDates, compareText, compareTypeNumber } from '@app/helpers/comparators';


const ListaAgrupadores = () => {

    const [list, setList] = useState<IRelatorioCentroDeCustoResult[]>([]);

    const getList = () => {
        getAllCrfProjetoContaContabilCcRelatorioCentroDeCustoForcast()
            .then(response => {
                if (response && Array.isArray(response)) {
                    setList(response);
                }
            });
    }

    useEffect(() => {
        getList();
    }, []);

    const columns = useMemo(() => {
        const colluns: ui.ColumnProps<any>[] = [];

        colluns.push({
            title: 'N',
            dataIndex: 'idx',
            width: '1%',
        },
            {
                title: 'Nº Projeto',
                dataIndex: 'projetoNumero',
                ...mountFormFilterDropDown("projetoNumero", "Perquisar"),
                sorter: (a, b) => compareText(a.projetoNumero, b.projetoNumero),
            },
            {
                title: 'Código Projeto',
                dataIndex: 'projetoCodigo',
                ...mountFormFilterDropDown("projetoCodigo", "Perquisar"),
                sorter: (a, b) => compareText(a.projetoCodigo, b.projetoCodigo),
            },
            {
                title: 'Nome Projeto',
                dataIndex: 'projetoNome',
                ...mountFormFilterDropDown("projetoNome", "Perquisar"),
                sorter: (a, b) => compareText(a.projetoNome, b.projetoNome),
            },
            {
                title: 'Conta Contábil',
                dataIndex: 'codigoContaContabil',
                ...mountFormFilterDropDown("codigoContaContabil", "Perquisar"),
                sorter: (a, b) => compareTypeNumber(a.codigoContaContabil, b.codigoContaContabil),
            },
            {
                title: 'Nome',
                dataIndex: 'nomeContaContabil',
                ...mountFormFilterDropDown("nomeContaContabil", "Perquisar"),
                sorter: (a, b) => compareText(a.nomeContaContabil, b.nomeContaContabil),
            },
            {
                title: 'Código Agrupador',
                dataIndex: 'codigoAgrupador',
                ...mountFormFilterDropDown("codigoAgrupador", "Perquisar"),
                sorter: (a, b) => compareText(a.codigoAgrupador, b.codigoAgrupador),
            },
            {
                title: 'Situação',
                dataIndex: 'situacao',
                ...mountFormFilterDropDown("situacao", "Perquisar"),
                sorter: (a, b) => compareText(a.situacao, b.situacao),
            },
            {
                title: 'RFA',
                dataIndex: 'rfa',
                ...mountFormFilterDropDown("rfa", "Perquisar"),
                sorter: (a, b) => compareText(a.rfa, b.rfa),
            },
            {
                title: 'Data',
                dataIndex: 'dataContaContabilCc',
                ...mountFormFilterDropDown("dataContaContabilCc", "Perquisar"),
                sorter: (a, b) => compareDates(a.dataContaContabilCc, b.dataContaContabilCc),
            },
            {
                title: 'DIR',
                dataIndex: 'siglaDiretoria',
                ...mountFormFilterDropDown("siglaDiretoria", "Perquisar"),
                sorter: (a, b) => compareText(a.siglaDiretoria, b.siglaDiretoria),
            },
            {
                title: 'ÁREA',
                dataIndex: 'siglaArea',
                ...mountFormFilterDropDown("siglaArea", "Perquisar"),
                sorter: (a, b) => compareText(a.siglaArea, b.siglaArea),
            },
            {
                title: 'DEP',
                dataIndex: 'siglaDepartamento',
                ...mountFormFilterDropDown("siglaDepartamento", "Perquisar"),
                sorter: (a, b) => compareText(a.siglaDepartamento, b.siglaDepartamento),
            },
            {
                title: 'Responsável',
                dataIndex: 'responsavel',
                ...mountFormFilterDropDown("responsavel", "Perquisar"),
                sorter: (a, b) => compareText(a.responsavel, b.responsavel),
            },
        );

        return colluns;
    }, []);

    return (
        <ui.SimpleView>
            <ui.GridView noform>
                <ui.Widget
                    title="Relatório de Centro de Custo - Conta Contábil"
                    actions={[
                        <ui.Button
                            type="primary"
                            title="Exportar para Excel"
                            icon="data-database"
                            onClick={() => {
                                exportarCrfProjetoContaContabilCcRelatorioCentroDeCustoForcast();
                            }}
                        />,
                    ]}
                    span={12}
                >
                    <ui.Table
                        rowKey="idx"
                        columns={columns}
                        dataSource={list}
                    />
                </ui.Widget>
            </ui.GridView>
        </ui.SimpleView >
    )
}

export default ListaAgrupadores